import { render, staticRenderFns } from "./NewSaleFromBarcodeReads.vue?vue&type=template&id=32bf8c5e&scoped=true&"
import script from "./NewSaleFromBarcodeReads.vue?vue&type=script&lang=ts&"
export * from "./NewSaleFromBarcodeReads.vue?vue&type=script&lang=ts&"
import style0 from "./NewSaleFromBarcodeReads.vue?vue&type=style&index=0&id=32bf8c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf8c5e",
  null
  
)

export default component.exports